import moment from "moment";
const TYPE = "orcamento";

const orcamentoModule = {
  buscarAtivosInativos: async (dbConnection) => {
    let orcamentos = [];
    const data =
      moment()
        .startOf("day")
        .subtract(5, "days")
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss") + ".000Z";

    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        data: {
          $lt: data,
        },

        $or: [
          {
            status: "A",
          },
          {
            status: "I",
          },
        ],
      },
      fields: ["_id", "status", "data", "dataExpiracao"],
    });

    if (result.docs.length) {
      orcamentos = result.docs;
    }

    return orcamentos;
  },

  findById: async (dbConnection, idOrcamento) => {
    return await _findById(dbConnection, idOrcamento);
  },

  totalOrcamentos: async (dbConnection) => {
    let orcamentos = [];
    let dataInicial = moment().startOf("month").utc();
    let dataFinal = moment().endOf("day").utc();

    dataInicial = dataInicial.format("YYYY-MM-DD HH:mm:ss");
    dataFinal = dataFinal.format("YYYY-MM-DD HH:mm:ss");

    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        data: {
          $gte: dataInicial,
          $lte: dataFinal,
        },
        status: { $eq: "A" },
      },
      fields: ["_id", "valorTotal", "cliente.idIntegracao", "idAgenda"],
      limit: 1000,
    });

    if (result.docs.length) {
      orcamentos = result.docs;
    }

    return orcamentos;
  },

  atualizarUrlPdf: async (dbConnection, idOrcamento, urlPdf, sincPdf) => {
    let orcamento = null;

    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        _id: { $eq: idOrcamento },
      },
      limit: 1,
    });

    if (result.docs.length) {
      orcamento = result.docs[0];
    }

    if (orcamento !== null) {
      orcamento.sincPdf = sincPdf;
      orcamento.urlPdf = urlPdf;
      await dbConnection.post(orcamento);
    }
  },

  inativar: async (dbConnection, orcamentoBuscar) => {
    let orcamento = await _findById(dbConnection, orcamentoBuscar._id);
    orcamento.status = "I";
    orcamento.dataExpiracao = new Date();
    await dbConnection.put(orcamento);
  },

  cancelar: async (dbConnection, orcamentoBuscar) => {
    let orcamento = await _findById(dbConnection, orcamentoBuscar._id);

    let orcamentoAnt = {
      _id: orcamento._id,
      _rev: orcamento._rev,
      idPedido: null,
      sinc: orcamento.sinc,
      valorTotal: orcamento.valorTotal,
      data: orcamento.data,
      status: "C",
      vendedor: orcamento.vendedor,
      type: "orcamento",
    };
    await dbConnection.put(orcamentoAnt);
  },
};
export default orcamentoModule;

const getExpiracao = (pedidos) => {
  for (let item of pedidos) {
    let permitidoAlteracao = true;
    let expiracao = {
      cor: "vermelho",
      texto: "Expira hoje",
    };
    let dataExpiracao = moment(item.data.toString().split("T")[0]).add(
      5,
      "days"
    );

    let duration = moment.duration(
      dataExpiracao.diff(moment().format("YYYY-MM-DD"))
    );
    let diferenca = parseInt(duration.asDays());

    if (item.status === "I" || diferenca < 0) {
      expiracao = {
        cor: "cinza",
        texto: "Expirado",
      };
      permitidoAlteracao = false;
    } else {
      if (diferenca === 0) {
        expiracao = {
          cor: "vermelho",
          texto: "Expira hoje",
        };
      }

      if (diferenca === 1) {
        expiracao = {
          cor: "laranja",
          texto: "Expira amanhã",
        };
      }
      if (diferenca > 1) {
        expiracao = {
          cor: "verde",
          texto: `Expira em ${diferenca} dias`,
        };
      }
    }
    expiracao.permitidoAlteracao = permitidoAlteracao;
    item.expiracao = expiracao;
  }
  return pedidos;
};

const _findById = async (dbConnection, idOrcamento) => {
  let orcamento = null;

  let result = await dbConnection.find({
    selector: {
      type: { $eq: TYPE },
      _id: { $eq: idOrcamento },
    },
  });

  if (result.docs.length) {
    orcamento = result.docs[0];
    let lista = [];
    lista.push(orcamento);
    lista = getExpiracao(lista);
    orcamento = lista[0];
  }

  return orcamento;
}
